import React from 'react';
import { useSelector } from 'react-redux';
import { matchPath, Navigate, Outlet, useLocation } from 'react-router-dom';
import { authSelector } from '../store/slices/auth-slice';

const UNRESTRICTED_PATHS = [
  '/catalog-type',
  '/clients',
  '/orders',
  '/my-account',
  '/orders/:orderId',
  '/orders/:orderId/createReturn',
  '/orders/:orderId/createSubstitution',
  '/orders/:orderId/:returnId',
  '/downloads',
];

const ProtectedRoute = () => {
  let { pathname } = useLocation();
  const { accessToken, client } = useSelector(authSelector);
  const isAuthenticated = !!accessToken;

  if (!isAuthenticated) {
    return <Navigate to={process.env.PUBLIC_URL + '/login'} replace />;
  }

  const isUnrestricted = UNRESTRICTED_PATHS.some((route) =>
    matchPath({ path: route, end: true }, pathname)
  );

  if (pathname === '/') {
    return <Navigate to={process.env.PUBLIC_URL + '/catalog-type'} replace />;
  }

  if (!isUnrestricted && !client) {
    return <Navigate to={process.env.PUBLIC_URL + '/catalog-type'} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
